export class Constants {
  // static apiAddress = "https://api.bestbuymall.co/super_admin";
  // static apiAddress =
  //   "https://rb3phgwqhl.execute-api.ap-southeast-1.amazonaws.com/bbm-dev/super_admin";
  static is_prod = false; //For Dev
  static apiAddress = Constants.is_prod===false? "https://api-uk.dev.bestbuymall.co/super_admin":"https://api-uk.bestbuymall.co/super_admin";

  // static is_prod = true; //For Production


  static iconForSinglePrice = "£ ";
  static iconForDoublePrice = "£ ";

  // use this command to build
  // node --max_old_space_size=8000 ./node_modules/@angular/cli/bin/ng build --prod
}



// WEBPACK FOOTER //
// ./src/app/constants.ts